export const OPEN_REALIGN_MODAL = 'OPEN_REALIGN_MODAL';
export const CLOSE_REALIGN_MODAL = 'CLOSE_REALIGN_MODAL';
export const SET_PARENT_OBJECTIVE_ID_REALIGN_MODAL = 'SET_PARENT_OBJECTIVE_ID_REALIGN_MODAL';
export const SET_TIMEBOUND_DETAILS_REALIGN_MODAL = 'SET_TIMEBOUND_DETAILS_REALIGN_MODAL';
export const SET_OBJECTIVE_REALIGN_MODAL = 'SET_OBJECTIVE_REALIGN_MODAL';
export const SET_SELECTED_OBJECTIVE_REALIGN_MODAL = 'SET_SELECTED_OBJECTIVE_REALIGN_MODAL';
